export default function (context, val) {
    let form = context.state;
    form.dateType = val.dateType;
    form.CurrencyIds = val.CurrencyIds;
    form.SumFrom = val.SumFrom;
    form.SumTo = val.SumTo;
    form.AvailableSumFrom = val.AvailableSumFrom;
    form.AvailableSumTo = val.AvailableSumTo;
    form.ContragentId = val.ContragentId;
    form.ContragentName = val.ContragentName;
    form.ContragentSearchTypeId = val.ContragentSearchTypeId;
    form.Number = val.Number;
    form.Type = val.Type;
    form.OwnerLegalEntityId = val.OwnerLegalEntityId;
    form.IsUsed = val.IsUsed;
    form.IsPayed = val.IsPayed;

    let dFrom = new Date(), dTo = new Date();
    switch (val.dateStep) {
        case 1:
            dFrom.setDate(dFrom.getDate() - val.dateInt);
            break;
        case 2:
            dFrom.setDate(dFrom.getDate() - val.dateInt * 7);
            break;
        case 3:
            dFrom.setMonth(dFrom.getMonth() - val.dateInt);
            if (val.dateRound) {
                // dFrom.setMonth(dFrom.getMonth());
                dFrom.setDate(1);
            }
            break;
    }

    form.dates = [
        '' + (dFrom.getDate() > 9 ? '' : '0') + dFrom.getDate() + '.' + (dFrom.getMonth() > 8 ? '' : '0') + (dFrom.getMonth() + 1) + '.' + dFrom.getFullYear(),
        '' + (dTo.getDate() > 9 ? '' : '0') + dTo.getDate() + '.' + (dTo.getMonth() > 8 ? '' : '0') + (dTo.getMonth() + 1) + '.' + dTo.getFullYear()
    ];
    if (val.searchClick) {
        context.dispatch('finances/certificates/search', null, {root: true});
    }
}